import { Button, Divider, Typography } from "@mui/material";
import SSOLogo from "assets/ssoLogo";

const LoginLeftErrorPanel = ({triggerLogin, requestAccess}: any) => {

    return (
        <div style={{ padding: "8px", textAlign: "center", display: "flex", flexDirection: "column", gap: "40px" }}>
            <Typography fontSize={"36px"} fontWeight={"600"}>Welcome to <br /> Connected vehicle - Data <br /> Analytics Dashboard</Typography>
            <Typography fontSize={"32px"} >{`Sorry Looks like you don’t have access`}</Typography>
            <div style={{
                padding: "24px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: "40px",
            }}>
                <Button
                    onClick={requestAccess}
                    sx={{
                        borderRadius: 50,
                        px: 2,
                        color: "black",
                        borderColor: "black"
                    }}
                    variant="outlined"
                >
                    Request Access
                </Button>
                <Divider>
                    <Typography >{"OR"}</Typography>
                </Divider>
                <Button
                    startIcon={<SSOLogo />}
                    onClick={triggerLogin}
                    sx={{
                        borderRadius: 50,
                        px: 2,
                        color: "black",
                        borderColor: "black",
                    }}
                    variant="outlined"
                >
                    Login With SSO
                </Button>
            </div>
        </div>
    );
};

export default LoginLeftErrorPanel;